const { showError, showNotifikasi } = require('../../libs/helper');
var qs = require('qs');

module.exports = {
    getDetail: (g, params) => {
        let result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ba-tim/detail',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            console.log(err)
        })
        return result;

    },
    getWilayah: (g, params = null) => {
        let result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ref/get-wilayah',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            console.log(err)
        })
        return result;

    },
    getKolokDs: async (g, params) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ref/get-kolok',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Get Data`)
        })
        return result;

    },
    getNrkSingleData: async (g, params) => {
        let payload = { ...params }
        payload.nrk = parseInt(payload.nrk);
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ref/get-pegawai-eksternal',
            method: 'post',
            data: qs.stringify(payload),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Get Data`)
        })
        return result;
    },
    save: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ba-tim/submit',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                showError(g, err, `Error Submit Form`)
            })
        return result;

    },
}